import { useState, useEffect } from "react";
import { INTEGRATION_TRADE_CODE_FOR_AUTHORIZATION } from "lib/constants";
import { getAPICall } from "lib/callApi";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "utils/Loader";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function OauthCb() {
  const navigate = useNavigate();
  const location = useLocation();
  const integrationHandler = location?.pathname?.split?.("/oauth/cb/")?.[1];
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  useEffect(() => {
    if (code && integrationHandler) {
      (async () => {
        try {
          setIsLoading(true);
          const result = await getAPICall(
            `${INTEGRATION_TRADE_CODE_FOR_AUTHORIZATION}/${integrationHandler}${window.location.search}`,
            true
          );
          if (result.status === 200) {
            setShouldRedirect(true);
          } else {
            let message =
              result?.response?.data?.message ||
              "Failed to complete the integration. Please try again later.";
            if (result?.response?.data?.errDetails) {
              Object.entries(result.response.data.errDetails).forEach(([key, value]) => {
                message += `\n${key}: ${value}`;
              });
            }
            setError(message);
          }
        } catch (err) {
          setError(err.message || "An unexpected error occurred. Please try again later.");
        } finally {
          setIsLoading(false);
        }
      })();
    }
  }, [code, integrationHandler]);

  useEffect(() => {
    if (shouldRedirect) {
      navigate("/settings?selectedTab=integrations");
    }
  }, [shouldRedirect]);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "1rem",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <ErrorOutlineIcon color="error" style={{ fontSize: 48 }} />
        <h2>{integrationHandler} Token Exchange Error</h2>
        <MDTypography
          variant="p"
          style={{
            whiteSpace: "pre-line",
            textAlign: "left",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          {error}
        </MDTypography>
        <div style={{ display: "flex", gap: "1rem" }}>
          <MDButton
            color="primaryBlack"
            size="medium"
            cursor="pointer"
            onClick={() => setShouldRedirect(true)}
          >
            Back To Integrations
          </MDButton>
        </div>
      </div>
    );
  }

  return <Loader loading={isLoading} />;
}

export default OauthCb;
